<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="bg-white pd-10">
      <!-- 返回按钮 -->
      <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
        @click="$router.push('/zoneManage/zoneIndex')"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>

      <!-- 按钮 -->
      <div class="mgt-20">
        <el-button @click="goShebei">分配设备</el-button>
        <el-button @click="zonePeopleClick">分配员工</el-button>
        <el-button @click="goCard">分配水卡</el-button>
        <el-button @click="goControl">一键控制</el-button>
        <!-- <el-button @click="goControl">迁移服务</el-button>
        <el-button @click="goControl">迁移记录</el-button> -->
      </div>

      <!-- 信息 -->
      <div class="mgt-30">
        <el-descriptions :column="3" border>
          <el-descriptions-item label="分区名称">{{
            infoForm.regionName
          }}</el-descriptions-item>
          <el-descriptions-item label="组内设备数">{{
            totalShebei
          }}</el-descriptions-item>
          <el-descriptions-item label="组内员工数">{{
            totalPeople
          }}</el-descriptions-item>
          <el-descriptions-item label="组内水卡数（实物卡/电子卡）">{{
            newCardForm.cardNum +
            "（" +
            newCardForm.entityCardNum +
            "/" +
            newCardForm.eleCardNum +
            "）"
          }}</el-descriptions-item>
          <el-descriptions-item label="组内客户数">{{
            totalClient
          }}</el-descriptions-item>
          <el-descriptions-item label="充值订单数">{{
            orderForm.rechargeNum
          }}</el-descriptions-item>
          <el-descriptions-item label="充值金额（赠送/实收）">{{
            (
              Number(orderForm.rechargeGive) + Number(orderForm.rechargeReal)
            ).toFixed(2) +
            "（" +
            orderForm.rechargeGive +
            "/" +
            orderForm.rechargeReal +
            "）"
          }}</el-descriptions-item>
          <el-descriptions-item label="消费订单数">{{
            xiaofeiForm.orderNum
          }}</el-descriptions-item>
          <el-descriptions-item label="消费金额（赠送/实收）">{{
            (
              Number(xiaofeiForm.discountPrice) + Number(xiaofeiForm.payPrice)
            ).toFixed(2) +
            "（" +
            xiaofeiForm.discountPrice +
            "/" +
            xiaofeiForm.payPrice +
            "）"
          }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{
            infoForm.createTime
          }}</el-descriptions-item>
          <el-descriptions-item label="分区简介">{{
            infoForm.regionDesc ? infoForm.regionDesc : "- -"
          }}</el-descriptions-item>
          <el-descriptions-item label="分区地址">{{
            infoForm.remark ? infoForm.remark : "- -"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- =========== -->

      <!-- 表格选项 -->
      <div class="flex aic jcsb mgt-10">
        <div class="selectBox">
          <div
            :class="selectActive === v.id ? 'selectActive' : 'select'"
            v-for="v in selectArr"
            :key="v.id"
            @click="selectTypeChange(v)"
          >
            {{ v.name }}
          </div>
        </div>

        <div class="chaxun flex aic">
          <div
            class="flex aic"
            v-if="
              selectActive !== 1 &&
              selectActive !== 2 &&
              selectActive !== 4 &&
              selectActive !== 5
            "
          >
            <div class="mgr-10">是否绑定</div>
            <el-select
              clearable
              class="mgr-15"
              v-model="isBindCard"
              placeholder="全部"
            >
              <el-option label="未绑定" value="0"> </el-option>
              <el-option label="已绑定" value="1"> </el-option>
            </el-select>
          </div>
          <el-input
            v-if="selectActive !== 4"
            v-model="queryData"
            :placeholder="
              selectActive == 1
                ? '请输入设备编号'
                : selectActive == 2
                ? '请输入员工手机号'
                : selectActive == 3
                ? '请输入水卡编号'
                : selectActive == 5
                ? '请输入客户手机号'
                : '- -'
            "
          ></el-input>
          <el-button
            v-if="selectActive !== 4"
            class="mgl-15"
            type="primary"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button
            v-if="selectActive !== 4"
            class="mgl-15"
            @click="
              queryData = '';
              isBindCard = '';
              getShebei();
              getPeople();
              getCard();
              getClient();
            "
            >重置</el-button
          >
        </div>
      </div>
      <!--  -->

      <!-- 移除和导出按钮 -->
      <div class="flex aic mgt-15">
        <el-button
          @click="allDel"
          v-if="selectActive !== 4 && selectActive !== 5"
          >移除</el-button
        >
        <el-button
          @click="exportBtn"
          v-if="selectActive !== 2 && selectActive !== 4"
          >导出</el-button
        >
      </div>

      <!-- 组内设备表格 -->
      <div class="mgt-30" v-show="selectActive == 1">
        <keep-alive>
          <el-table
            :data="shebeiTable"
            border
            stripe
            style="width: 100%"
            @selection-change="handleSelectionChange1"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              type="index"
              :index="indexMethod"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column prop="equipmentNum" label="设备编号">
            </el-table-column>
            <el-table-column prop="name" label="设备名称"> </el-table-column>
            <el-table-column prop="equipmentVersion" label="设备型号">
            </el-table-column>
            <el-table-column prop="address" label="启用状态">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.usingStatus === 0
                      ? '禁用'
                      : scope.row.usingStatus === 1
                      ? '启用'
                      : ''
                  "
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="设备状态">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.error == 0
                      ? '正常'
                      : scope.row.error == 1
                      ? '异常'
                      : '--'
                  "
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="联网状态">
              <template slot-scope="scope">
                <span v-text="scope.row.status === 0 ? '离线' : '在线'"> </span>
              </template>
            </el-table-column>
            <el-table-column prop="equipmentPlace" label="设备位置">
            </el-table-column>
            <el-table-column prop="createTime" label="添加时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDelShebei(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </keep-alive>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangeShebei"
          @current-change="handleCurrentChangeShebei"
          :current-page="pageShebei"
          :page-size="pageSizeShebei"
          :page-sizes="[5, 20, 30, 40, 50]"
          layout=" prev, pager, next"
          :total="totalShebei"
        >
        </el-pagination>
      </div>
      <!--  -->
      <!-- 组内员工表格 -->
      <div class="mgt-30" v-show="selectActive == 2">
        <el-table
          :data="peopleTable"
          border
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange2"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            :index="indexMethod2"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="name" label="员工姓名">
            <template slot-scope="scope">
              <span v-text="scope.row.name ? scope.row.name : '- -'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="员工手机号">
            <template slot-scope="scope">
              <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="充值订单数">
            <template slot-scope="scope">
              <span
                v-text="scope.row.orderNum ? scope.row.orderNum : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="充值金额（赠送/实收）">
            <template slot-scope="scope">
              <span
                v-text="
                  Number(scope.row.giveMoney) +
                  Number(scope.row.payMoney) +
                  '（' +
                  scope.row.giveMoney +
                  '/' +
                  scope.row.payMoney +
                  '）'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间">
            <template slot-scope="scope">
              <span
                v-text="scope.row.createTime ? scope.row.createTime : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDelPeople(scope.row)"
                >移除</el-button
              >
              <!-- <el-button
                type="text"
                size="small"
                @click="handleDelPeopleScode(scope.row)"
                >推荐码</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangePeople"
          @current-change="handleCurrentChangePeople"
          :current-page="pagePeople"
          :page-size="pageSizePeople"
          :page-sizes="[5, 20, 30, 40, 50]"
          layout=" prev, pager, next"
          :total="totalPeople"
        >
        </el-pagination>
      </div>
      <!--  -->

      <!-- 组内水卡表格 -->
      <div class="mgt-30" v-show="selectActive == 3">
        <keep-alive>
          <el-table
            :data="cardTable"
            border
            stripe
            style="width: 100%"
            @selection-change="handleSelectionChange3"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              type="index"
              :index="indexMethod3"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column prop="cardId" label="卡号"> </el-table-column>
            <el-table-column prop="status" label="水卡类型">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.cardType === 1
                      ? '电子卡'
                      : scope.row.cardType === 2
                      ? '实物卡'
                      : scope.row.cardType === 3
                      ? '时效电子卡'
                      : scope.row.cardType === 4
                      ? '时效实物卡'
                      : '- -'
                  "
                ></span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="是否绑定">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.status === 0
                      ? '未绑定'
                      : scope.row.status === 1
                      ? '已绑定'
                      : '- -'
                  "
                ></span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="水卡状态">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.cardStatus === 0
                      ? '正常'
                      : scope.row.cardStatus === 1
                      ? '挂失'
                      : scope.row.cardStatus === 2
                      ? '异常'
                      : scope.row.cardStatus == 3
                      ? '已失效'
                      : '- -'
                  "
                ></span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="添加时间">
              <template slot-scope="scope">
                <span
                  v-text="scope.row.createTime ? scope.row.createTime : '- -'"
                ></span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDelCard(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </keep-alive>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangeCard"
          @current-change="handleCurrentChangeCard"
          :current-page="pageCard"
          :page-size="pageSizeCard"
          :page-sizes="[5, 20, 30, 40, 50]"
          layout=" prev, pager, next"
          :total="totalCard"
        >
        </el-pagination>
      </div>
      <!--  -->

      <!-- 组内合伙人表格 -->
      <div class="mgt-30" v-show="selectActive == 4">
        <keep-alive>
          <el-table :data="partnerTable" border stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column
              type="index"
              :index="indexMethod4"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column prop="userName" label="合伙人姓名">
            </el-table-column>
            <el-table-column prop="phone" label="合伙人手机号">
            </el-table-column>
            <el-table-column prop="shareRatio" label="分润比例">
            </el-table-column>
            <el-table-column prop="recoveryTime" label="添加时间">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.recoveryTime ? scope.row.recoveryTime : '- -'
                  "
                ></span>
              </template>
            </el-table-column>
          </el-table>
        </keep-alive>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangePartner"
          @current-change="handleCurrentChangePartner"
          :current-page="pagePartner"
          :page-size="pageSizePartner"
          :page-sizes="[5, 20, 30, 40, 50]"
          layout=" prev, pager, next"
          :total="totalPartner"
        >
        </el-pagination>
      </div>
      <!--  -->

      <!-- 组内客户表格 -->
      <div class="mgt-30" v-show="selectActive == 5">
        <keep-alive>
          <el-table :data="clientTable" border stripe style="width: 100%">
            <el-table-column
              type="index"
              :index="indexMethod6"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="客户昵称">
            </el-table-column>
            <el-table-column prop="customerPhone" label="客户电话">
            </el-table-column>
            <el-table-column prop="addTime" label="创建时间"> </el-table-column>
          </el-table>
        </keep-alive>
        <!-- 分页器 -->
        <el-pagination
          class="mgt-20"
          background
          @size-change="handleSizeChangeClient"
          @current-change="handleCurrentChangeClient"
          :current-page="pageClient"
          :page-size="pageSizeClient"
          :page-sizes="[5, 20, 30, 40, 50]"
          layout=" prev, pager, next"
          :total="totalClient"
        >
        </el-pagination>
      </div>
      <!--  -->

      <!-- 分配员工弹框 -->
      <el-dialog
        title="分配员工"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :close-on-click-modal="false"
        top="30vh"
      >
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="员工" prop="people">
            <el-select
              multiple
              filterable
              v-model="form.people"
              placeholder="请选择需要分配的管理员工"
            >
              <el-option
                v-for="(v, i) in userArr"
                :key="i"
                :label="v.name"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="mgr-30" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="peopleBinClick('form')"
            >分 配</el-button
          >
        </span>
      </el-dialog>
    </div>

    <!-- 区域迁移服务弹框 -->
    <el-dialog
      title="区域迁移服务"
      :visible.sync="qianyiVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="mgl-100">
        <div class="fw-600 mgb-10">迁移至</div>
        <el-radio v-model="qianyiChange" :label="1">社区售水机</el-radio>
        <el-radio v-model="qianyiChange" :label="2">楼宇单元售水机</el-radio>
        <div class="colorRed mgt-15">
          温馨提示：将区域内设备和水卡迁移服务后，用户将使用新小程序购水。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="qianyiVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="qianyiVisible = false"
          >迁 移</el-button
        >
      </span>
    </el-dialog>
    <!-- 区域迁移服务记录弹框 -->
    <el-dialog
      title="区域迁移服务记录"
      :visible.sync="qianyijiluVisible"
      width="45%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-table :data="jiluTable" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod5"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="date" label="迁移服务"> </el-table-column>
        <el-table-column prop="name" label="迁移状态"> </el-table-column>
        <el-table-column prop="address" label="操作人"> </el-table-column>
        <el-table-column prop="address" label="操作时间"> </el-table-column>
        <el-table-column prop="address" label="迁移时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChangeJilu"
        @current-change="handleCurrentChangeJilu"
        :current-page="pageJilu"
        :page-size="pageSizeJilu"
        :page-sizes="[5, 20, 30, 40, 50]"
        layout=" prev, pager, next"
        :total="totalJilu"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="qianyijiluVisible = false"
          >已知晓</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="推荐码"
      :visible.sync="qianyijiluVisibleScocde"
      width="45%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <QrCodeGenerator ref="Scode" v-if="showQr" :url="qrUrl" />
      <span slot="footer" class="dialog-footer">
        <el-button class="" @click="$refs.Scode.downloadQR()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import breadcrumbs from "@/components/breadcrumbs.vue";
import QrCodeGenerator from "./QrCodeGenerator.vue";
import { baseURL } from "@/utils/fetch.js";
export default {
  components: {
    breadcrumbs,
    QrCodeGenerator,
  },
  data() {
    return {
      qianyijiluVisibleScocde: false,
      showQr: false,
      qrUrl: "",
      infoForm: {
        regionName: "",
        deviceNum: "",
        userNum: "",
        cardNum: "",
        createTime: "",
        regionDesc: "",
        remark: "",
      },
      newCardForm: {
        cardNum: 0,
        entityCardNum: 0,
        eleCardNum: 0,
      },
      selectArr: [
        { id: 1, name: "组内设备" },
        { id: 2, name: "组内员工" },
        { id: 3, name: "组内水卡" },
        //{ id: 4, name: "合伙人" },
        { id: 5, name: "组内客户" },
      ],
      selectActive: 1,
      shebeiTable: [], //组内设备
      // 分页数据
      pageShebei: 1, // 当前页，默认
      pageSizeShebei: 15, //每页显示多少条数据，默认
      totalShebei: 50, // 数据总条数
      // 分页数据
      pageJilu: 1, // 当前页，默认
      pageSizeJilu: 15, //每页显示多少条数据，默认
      totalJilu: 50, // 数据总条数
      peopleTable: [], //组内员工设备
      // 分页数据
      pagePeople: 1, // 当前页，默认
      pageSizePeople: 15, //每页显示多少条数据，默认
      totalPeople: 50, // 数据总条数
      cardTable: [], //组内水卡设备
      // 分页数据
      pageCard: 1, // 当前页，默认
      pageSizeCard: 15, //每页显示多少条数据，默认
      totalCard: 50, // 数据总条数
      // 分页数据
      pageClient: 1, // 当前页，默认
      pageSizeClient: 15, //每页显示多少条数据，默认
      totalClient: 50, // 数据总条数
      clientTable: [],
      // 分页数据
      pagePartner: 1, // 当前页，默认
      pageSizePartner: 15, //每页显示多少条数据，默认
      totalPartner: 50, // 数据总条数
      dianzi: [],
      shiwu: [],
      dialogVisible: false, //分配员工弹框
      form: {
        people: [],
      },
      rules: {
        people: [
          { required: true, message: "请选择管理员工", trigger: "blur" },
        ],
      },
      zoneId: null,
      userArr: [],
      multipleSelection1: [], //设备多选数组
      multipleSelection2: [], //员工多选数组
      multipleSelection3: [], //水卡多选数组
      queryData: "", //三合一查询表单
      companyId: null,
      orderForm: {},
      xiaofeiForm: {},
      isBindCard: "",
      partnerTable: [],
      qianyiVisible: false,
      qianyiChange: 1,
      qianyijiluVisible: false,
      jiluTable: [],
      qrText: "",
    };
  },
  created() {
    this.zoneId = this.$route.query.zoneId;
    this.companyId = this.$route.query.companyId;
    this.getInfo();
    this.getShebei();
    this.getCard();
    this.getPeople();
    this.getUser();
    this.getXiaofei();
    this.getChongzhi();
    this.getPartner();
    this.getClient();
    this.getCardNumNew();
  },
  mounted() {},
  watch: {
    url(newVal) {
      this.qrText = newVal; // URL变化时更新二维码内容
    },
  },
  methods: {
    // 迁移记录表格
    getJilu(pageNum) {
      if (!pageNum) {
        this.pageJilu = 1;
      }
    },
    getCardNumNew() {
      this.$api.zone.zoneCardNum({ id: this.zoneId }).then((res) => {
        if (res.code === 200) {
          this.newCardForm = res.data;
        }
      });
    },
    getXiaofei() {
      this.$api.zone
        .xiaofeiState({ companyId: this.companyId, regionId: this.zoneId })
        .then((res) => {
          if (res.code === 200) {
            this.xiaofeiForm = res.data;
          }
        });
    },

    getChongzhi() {
      this.$api.zone
        .chongzhiState({ companyId: this.companyId, regionId: this.zoneId })
        .then((res) => {
          console.log(res, "充值统计");
          if (res.code === 200) {
            this.orderForm = res.data;
          }
        });
    },

    handleQuery() {
      if (this.selectActive == 1) {
        this.getShebei();
      } else if (this.selectActive == 2) {
        this.getPeople();
      } else if (this.selectActive == 3) {
        this.getCard();
      } else if (this.selectActive == 5) {
        this.getClient();
      }
    },
    // 导出
    exportBtn() {
      if (this.selectActive == 3) {
        handleConfirm("确认导出该区域水卡吗?", "info")
          .then(() => {
            this.$api.zone.cardExport({ regionId: this.zoneId }).then((res) => {
              handleAlert("导出成功", "success");
              this.exportVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute("download", "组内水卡.xls");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
          })
          .catch(() => {
            return;
          });
      } else if (this.selectActive == 1) {
        handleConfirm("确认导出该区域设备吗?", "info")
          .then(() => {
            this.$api.zone
              .equipmentExport({ regionId: this.zoneId })
              .then((res) => {
                handleAlert("导出成功", "success");
                this.exportVisible = false;
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(res);
                link.setAttribute("download", "组内设备.xls");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });
          })
          .catch(() => {
            return;
          });
      } else {
        handleConfirm("确认导出该区域客户吗?", "info")
          .then(() => {
            this.$api.zone
              .clientExport({ regionId: this.zoneId })
              .then((res) => {
                handleAlert("导出成功", "success");
                this.exportVisible = false;
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(res);
                link.setAttribute("download", "组内客户.xls");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });
          })
          .catch(() => {
            return;
          });
      }
    },

    // 批量删除
    allDel() {
      if (this.selectActive == 1) {
        if (this.multipleSelection1.length == 0) {
          handleAlert("请选择需要移除的设备", "error");
          return;
        }
        let arr = [];
        this.multipleSelection1.forEach((v) => {
          arr.push(Number(v.deviceId));
        });
        handleConfirm("移除分区后将自动禁用设备，是否确定移除?", "info")
          .then(() => {
            this.$api.zone.delShebei(arr).then((res) => {
              if (res.code === 200) {
                handleAlert("移除成功", "success");
                this.getShebei();
                this.getInfo();
              }
            });
          })
          .catch(() => {
            return;
          });
      } else if (this.selectActive == 2) {
        if (this.multipleSelection2.length == 0) {
          handleAlert("请选择需要移除的员工", "error");
          return;
        }

        let arr = [];
        this.multipleSelection2.forEach((v) => {
          arr.push(Number(v.regionUserId));
        });
        handleConfirm("确定将员工移除分区吗?", "info")
          .then(() => {
            this.$api.zone.delPeople(arr).then((res) => {
              if (res.code === 200) {
                handleAlert("移除成功", "success");
                this.getPeople();
                this.getInfo();
              }
            });
          })
          .catch(() => {
            return;
          });
      } else {
        if (this.multipleSelection3.length == 0) {
          handleAlert("请选择需要移除的水卡", "error");
          return;
        }
        let arr = [];
        this.multipleSelection3.forEach((v) => {
          if (v.cardType == 1) {
            arr.push(v);
          }
        });
        if (arr.length !== 0) {
          handleAlert("电子卡无法移除,请重新选择", "error");
          return;
        }
        let arr2 = [];
        this.multipleSelection3.forEach((v) => {
          arr2.push({
            id: v.id,
            regionCardId: v.regionCardId,
          });
        });
        handleConfirm("确定将水卡移除该分区吗?", "info")
          .then(() => {
            this.$api.zone.delCard(arr2).then((res) => {
              if (res.code === 200) {
                handleAlert("水卡移除成功", "success");
                this.getCard();
                this.getInfo();
                this.getCardNumNew();
              }
            });
          })
          .catch(() => {
            return;
          });
      }
    },
    // 员工下拉接口
    getUser() {
      this.$api.zone.peoplePull().then((res) => {
        if (res.code === 200) {
          this.userArr = res.data.list;
        }
      });
    },

    // 信息
    getInfo() {
      this.$api.zone.zoneInfo({ id: this.zoneId }).then((res) => {
        console.log("信息", res);

        if (res.code === 200) {
          this.infoForm = res.data;
        }
      });
    },

    // 组内设备表格
    getShebei(pageNum) {
      if (!pageNum) {
        this.pageShebei = 1;
      }
      this.$api.zone
        .shebeiTable({
          id: this.zoneId,
          pageNum: this.pageShebei,
          pageSize: this.pageSizeShebei,
          equipmentNum: this.queryData,
        })
        .then((res) => {
          if (res.code === 200) {
            this.shebeiTable = res.data.list;
            this.totalShebei = res.data.total;
          }
        });
    },

    // 组内客户表格
    getClient(pageNum) {
      if (!pageNum) {
        this.pageClient = 1;
      }
      this.$api.zone
        .zoneClient({
          regionId: this.zoneId,
          pageNum: this.pageClient,
          pageSize: this.pageSizeClient,
          customerPhone: this.queryData,
        })
        .then((res) => {
          if (res.code === 200) {
            this.clientTable = res.data.list;
            this.totalClient = res.data.total;
          }
        });
    },

    // 组内合伙人表格
    getPartner(pageNum) {
      if (!pageNum) {
        this.pagePartner = 1;
      }
      this.$api.partner
        .regionPartnerList({
          regionId: this.zoneId,
          pageNum: this.pagePartner,
          pageSize: this.pageSizePartner,
        })
        .then((res) => {
          if (res.code === 200) {
            this.partnerTable = res.data.rows;
            this.totalPartner = res.data.total;
          }
        });
    },

    // 组内设备移除
    handleDelShebei(row) {
      handleConfirm("移除分区后将自动禁用设备，是否确定移除?", "info")
        .then(() => {
          this.$api.zone.delShebei([Number(row.deviceId)]).then((res) => {
            if (res.code === 200) {
              handleAlert("移除成功", "success");
              this.getShebei();
              this.getInfo();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 组内水卡移除
    handleDelCard(row) {
      if (row.cardType === 1) {
        handleAlert("电子卡不允许移除，请重新选择", "error");
        return;
      }
      handleConfirm("确定将水卡移除该分区吗?", "info")
        .then(() => {
          let arr = [];
          arr = [
            {
              id: row.id,
              regionCardId: row.regionCardId,
            },
          ];
          this.$api.zone.delCard(arr).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡移除成功", "success");
              this.getCard();
              this.getInfo();
              this.getCardNumNew();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 组内员工移除
    handleDelPeople(row) {
      handleConfirm("确定将员工移除分区吗?", "info")
        .then(() => {
          this.$api.zone.delPeople([Number(row.regionUserId)]).then((res) => {
            if (res.code === 200) {
              handleAlert("移除成功", "success");
              this.getPeople();
              this.getInfo();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    handleDelPeopleScode(row) {
      let baseURL = 'https://api.mr-future.com/'
      this.qrUrl = `${baseURL}pay_?id=${this.zoneId}&roleId=${row.id}&roleName=${row.name}&rolePhone=${row.phone}`;
      //  this.qrUrl = "https://api.mr-future.com/pay_?id=179&roleId=182&roleName=胡景晖&rolePhone=15283849222"
      this.qianyijiluVisibleScocde = true;
      this.showQr = true;
    },
    // 组内水卡表格
    getCard(pageNum) {
      if (!pageNum) {
        this.pageCard = 1;
      }
      this.$api.zone
        .cardTable({
          regionId: this.zoneId,
          pageNum: this.pageCard,
          pageSize: this.pageSizeCard,
          cardNum: this.queryData,
          bindStatus: this.isBindCard,
        })
        .then((res) => {
          if (res.code === 200) {
            this.cardTable = res.data.list;
            this.dianzi = [];
            this.shiwu = [];
            res.data.list.forEach((v) => {
              if (v.cardType == 1) {
                this.dianzi.push(v);
              } else {
                this.shiwu.push(v);
              }
            });
            this.totalCard = res.data.total;
          }
        });
    },

    // 分配员工
    peopleBinClick(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认分配员工到该分区吗?", "info")
            .then(() => {
              let arr = [];
              this.form.people.forEach((v) => {
                arr.push({ userId: v, regionId: this.zoneId });
              });
              this.$api.zone.peopleBind(arr).then((res) => {
                if (res.code === 200) {
                  this.dialogVisible = false;
                  handleAlert("分配成功", "success");
                  this.getInfo();
                  this.getPeople();
                }
              });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 组内员工表格
    getPeople(pageNum) {
      if (!pageNum) {
        this.pagePeople = 1;
      }
      this.$api.zone
        .peopleTable({
          regionId: this.zoneId,
          pageNum: this.pagePeople,
          pageSize: this.pageSizePeople,
          phone: this.queryData,
        })
        .then((res) => {
          if (res.code === 200) {
            this.peopleTable = res.data.list;
            this.totalPeople = res.data.total;
          }
        });
    },

    // 选择
    selectTypeChange(item) {
      this.selectActive = item.id;
      this.queryData = "";
      this.getCard();
      this.getPeople();
      this.getShebei();
      this.getPartner();
      this.getClient();
    },

    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    handleSelectionChange3(val) {
      this.multipleSelection3 = val;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangeShebei(val) {
      this.pageSizeShebei = val;
      this.getShebei(this.pageShebei);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeShebei(val) {
      this.pageShebei = val;
      this.getShebei(this.pageShebei);
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangeJilu(val) {
      this.pageSizeJilu = val;
      this.getJilu(this.pageJilu);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeJilu(val) {
      this.pageJilu = val;
      this.getJilu(this.pageJilu);
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangePeople(val) {
      this.pageSizePeople = val;
      this.getPeople(this.pagePeople);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangePeople(val) {
      this.pagePeople = val;
      this.getPeople(this.pagePeople);
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangePartner(val) {
      this.pageSizePartner = val;
      this.getPartner(this.pagePartner);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangePartner(val) {
      this.pagePartner = val;
      this.getPartner(this.pagePartner);
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangeClient(val) {
      this.pageSizeClient = val;
      this.getClient(this.pageClient);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeClient(val) {
      this.pageClient = val;
      this.getClient(this.pageClient);
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangeCard(val) {
      this.pageSizeCard = val;
      this.getCard(this.pageCard);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeCard(val) {
      this.pageCard = val;
      this.getCard(this.pageCard);
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod2(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod3(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod4(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod6(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod5(index) {
      return index + 1;
    },
    // 分配设备
    goShebei() {
      this.$router.push({
        path: "/zoneManage/zoneShebei",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId,
        },
      });
    },
    // 分配员工
    zonePeopleClick() {
      this.dialogVisible = true;
      this.form = { people: [] };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.form.clearValidate();
      });
    },
    // 一键控制
    goControl() {
      this.$router.push({
        path: "/zoneManage/control",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId,
        },
      });
    },

    // 分配水卡
    goCard() {
      this.$router.push({
        path: "/zoneManage/zoneCard",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chaxun {
  .el-input {
    width: 200px;
  }
}
.selectBox {
  display: flex;
  margin-top: 20px;
  .select {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
  }

  .selectActive {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
    color: var(--accent);
  }
}

.el-table {
  width: 99.9% !important;
}
</style>
